<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import { useAppConfig } from '#app/config';
import DButton from '#layers/ui/components/Button.vue';
import DTooltip from '#layers/ui/components/Tooltip.vue';

defineOptions({
	name: 'ButtonEdit',
	inheritAttrs: false,
});

const {
	color = 'neutral',
	variant = 'ghost',
	...forwardedProps
} = defineProps<ButtonProps & { label?: string; tooltip?: string }>();

const appConfig = useAppConfig();
</script>

<template>
	<DTooltip
		:text="tooltip ?? label ?? $t('common.edit_item')"
	>
		<DButton
			data-testid="edit-button"
			class="text-muted"
			v-bind="{ ...forwardedProps, color, variant, ...$attrs }"
			:icon="appConfig.ui.icons.edit"
			:disabled
			:aria-label="label ?? $t('common.edit')"
		/>
	</DTooltip>
</template>
